export const registrationExpressEndpoints = {
  validateCode: 'auth/r/{country}/v1/register/code',
  validateData: 'crm/r/{country}/v1/customers/validate',
  documentTypes: 'crm/r/{country}/v1/document-types/active',
};
